import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './sanolivar-style.css';

import Name from './utils/Name.js';
import { root, assets } from './utils/Path';

import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';
import Form from './components/Form.jsx';
import Slider from './components/Slider.jsx';
import Chatbot from './components/Chatbot.jsx';

const assetsComputo = `${assets}images/computo/`;

createRoot(document.getElementById('computo')).render(
    <StrictMode>
        <Header active={"Datacenters"} />
        {/* BANNER */}
        <section className="banner endark">
            <div className="background">
                <video loading="lazy" autoPlay muted loop src={`./assets/videos/banner-computo.webm`} aria-label='Procesador visto desde un microscopio'></video>
            </div>
            <div>
                <h1>Productos de Cómputo</h1>
                <p>Acelera tu proceso de IA con la nube privada llave en mano de HPE y NVIDIA.</p>
            </div>
        </section>
        {/* ARTIFICIAL INTELLIGENCE */}
        <section className='compressed bg-alt'>
            <h2 data-aos="fade-up">HPE Private Cloud AI</h2>
            <p data-aos="fade-up" className='super-stretch centered'>Con NVIDIA AI Computing by HPE, puedes acelerar el proceso desde el piloto de inteligencia artificial hasta la producción con una nube privada de IA llave en mano.</p>
            <div className="c2 compressed bg-alt">
                <img loading="lazy" data-aos="fade-right" src={`${assetsComputo}hpe-hit.webp`} alt='Productos HPE Greenlake' aria-label='Productos HPE Greenlake' title='Productos HPE Greenlake' />
                <div data-aos="fade-left">
                    <h3>Acelera la productividad de los científicos de datos mientras mantienes tus datos privados y seguros.</h3>
                    <p>Simplifica la configuración acelerada de la infraestructura y proporciona la velocidad y escala de la nube pública, mientras mantienes tus datos privados y más seguros, con una plataforma de software de ciclo de vida global. Con una nube privada escalable, previamente probada, optimizada para la inteligencia artificial y totalmente acelerada, puedes dar a tus equipos de IA y TI la libertad de experimentar y escalar proyectos de inteligencia artificial con un completo ecosistema de modelos de IA y herramientas de desarrollo, todo ello mientras mantienes los costes y riesgos financieros bajo control.</p>
                </div>
            </div>
        </section>
        {/* HPE PRO LIANT */}
        <section className="compressed c2">
            <div data-aos="fade-right">
                <h2>Servidor HPE ProLiant DL380a Gen11</h2>
                <h3>HPE ProLiant DL380a Gen11 Optimizado para IA</h3>
                <p>Acelera la obtención de beneficios para tu empresa con soluciones de inferencia y ajuste de inteligencia artificial</p>
                <h3>Arquitectura ultra escalable</h3>
                <p>Hasta cuatro GPU de doble ancho para impulsar las cargas de trabajo de IA empresariales con la máxima aceleración</p>
                <h3>Seguro y fácil de gestionar</h3>
                <p>Seguridad de diseño fiable y manejo intuitivo de la nube para proteger las cargas de trabajo de tu infraestructura de inteligencia artificial</p>
            </div>
            <div data-aos="fade-left">
                <img loading="lazy" src={`${assetsComputo}hpe-hit2.webp`} alt='Rack HPE ProLiant' aria-label='Rack HPE ProLiant' title='Rack HPE ProLiant' />
                <p className="strong">Optimiza la inferencia y el ajuste en el centro de datos con computación de próxima generación que utiliza una arquitectura ultraescalable para la aceleración más avanzada de los datos y las GPU.</p>
            </div>
        </section>
        {/* HPC */}
        <section className='compressed bg-alt centered'>
            <h2 data-aos="fade-up">Infraestructura para HPC</h2>
            <p data-aos="fade-up" className='stretch centered'>Productos de supercomputación</p>
            <div className="c2">
                <div data-aos="fade-right">
                    <h3>HPE Supercomputing</h3>
                    <p>Aprovecha los productos de supercomputación para iniciar una revolución de la innovación y el descubrimiento en la era de la exaescala y más allá, para lograr resultados más rápidos y una inteligencia artificial acelerada.</p>
                    <img loading="lazy" style={{ maxHeight: '200px', objectFit: 'cover' }} src={`${assetsComputo}hpc.webp`} alt='Placa madre aumentada en microscopio' aria-label='Placa madre aumentada en microscopio' title='Placa madre aumentada en microscopio' />
                </div>
                <div data-aos="fade-left">
                    <h3>Ventajas de HPE Supercomputing</h3>
                    <strong>Innovación sin límites y resultados empresariales en menos tiempo</strong>
                    <p>Consigue un rendimiento colosal en investigación e innovación dentro de los sectores de la atención sanitaria y las ciencias biológicas, fabricación, energía, ciencias de la Tierra y finanzas, entre otros.</p>
                    <strong>Acelera la inteligencia artificial</strong>
                    <p>Consigue la escalabilidad, rendimiento y controles de costes que necesitas para optimizar todas las cargas de trabajo y acelerar la obtención de resultados de negocio.</p>
                    <strong>IA a escala y análisis de datos</strong>
                    <p>Entrena modelos de IA a escala desde la idea inicial hasta su implantación en la empresa con reescrituras mínimas del código o cambios en la infraestructura.</p>
                </div>
            </div>
        </section>
        {/* SYNERGY */}
        <section className="compressed">
            <h2 data-aos="fade-up">HPE Synergy</h2>
            <p data-aos="fade-up" className='super-stretch centered'>Una infraestructura de Blades componible que potencia cualquier carga de trabajo en un entorno híbrido.</p>
            <div className='c2'>
                <div style={{ alignSelf: 'center' }} data-aos="fade-right">
                    <p>HPE Synergy es una infraestructura componible y definida por software para entornos híbridos que te permite componer grupos fluidos de recursos de computación, almacenamiento y estructurales, físicos y virtuales, en cualquier configuración para cualquier carga de trabajo bajo una API unificada, todo ello disponible como servicio a través de HPE GreenLake.</p>
                    <p className='strong'>Una infraestructura para cualquier carga de trabajo</p>
                    <ul style={{ paddingLeft: '3ch', lineHeight: '2.5ch' }}>
                        <li>Desarrollo de aplicaciones de manera más rápida e inteligente</li>
                        <li>Implementa a escala y velocidad de nube</li>
                        <li>Automatizar las operaciones diarias</li>
                        <li>Consíguela como servicio de nube</li>
                        <li>Seguridad integral</li>
                    </ul>
                </div>
                <div data-aos="zoom-in-left" id='card-computo' shake='true' shake-perspective='1600' shake-floating='true' shake-angle='30' shake-glow='true' shake-shadow='true'>
                    <img loading="lazy" src={`${assetsComputo}synergy.webp`} alt='Personas inspeccionando infraestructura de computo' aria-label='Personas inspeccionando infraestructura de computo' title='Personas inspeccionando infraestructura de computo' />
                    <div shake-depth='3' className="overlay">
                        <span shake-depth='5'>35%</span>
                        <p shake-depth='4'>Menor coste de las operaciones</p>
                        <span shake-depth='5'>284%</span>
                        <p shake-depth='4'>ROI a 5 años</p>
                        <span shake-depth='5'>22%</span>
                        <p shake-depth='4'>Menor coste de la infraestructura de TI</p>
                    </div>
                </div>
            </div>
        </section>
        {/* OPINIONES */}
        {/* <section className='compressed' data-aos="fade-up">
            <h2>Opiniones Clientes</h2>
            <p className='stretch centered'>Descubre cómo nuestra nube privada de IA transforma tu negocio rápidamente.</p>
        </section> */}
        {/* <Slider content={
            <div data-aos="fade-left">
                <div className='witness stars5'>
                    <p>Gracias a la solución de HPE, hemos optimizado nuestros procesos de IA y mejorado la eficiencia operativa en poco tiempo.</p>
                    <div>
                        <img loading="lazy" src="./assets/images/placeholder.webp" alt="foto perfil cliente" aria-label="foto perfil cliente" title="foto perfil cliente" />
                        <span>Ana López</span>
                        <p>Barcelona</p>
                    </div>
                </div>
                <div className='witness stars4'>
                    <p>La nube privada de HPE ha acelerado nuestra implementación de IA de manera impresionante.</p>
                    <div>
                        <img loading="lazy" src="./assets/images/placeholder.webp" alt="foto perfil cliente" aria-label="foto perfil cliente" title="foto perfil cliente" />
                        <span>Carlos Ruiz</span>
                        <p>Madrid</p>
                    </div>
                </div>
                <div className='witness stars4'>
                    <p>La nube privada de HPE ha acelerado nuestra implementación de IA de manera impresionante.</p>
                    <div>
                        <img loading="lazy" src="./assets/images/placeholder.webp" alt="foto perfil cliente" aria-label="foto perfil cliente" title="foto perfil cliente" />
                        <span>Carlos Ruiz</span>
                        <p>Madrid</p>
                    </div>
                </div>
            </div>
        } customClass={'compressed'} /> */}
        <Form
            title={'Contáctanos para solicitar Asesoría en Infraestructura'}
            content={'Para más información sobre las distintas formas en que puede hacer uso de nuestra infraestructura tecnológica, por favor completa el formulario.'}
            img={{ src: `${assetsComputo}contacto.webp`, alt: 'Musgo creciendo sobre formación rocosa' }}
            form={[
                {
                    label: 'Nombre contacto',
                    type: 'text',
                    id: 'nombre',
                    placeholder: 'Ingrese su nombre aquí'
                },
                {
                    label: 'Correo electrónico',
                    type: 'email',
                    id: 'email',
                    placeholder: 'Ingrese su correo aquí'
                },
                {
                    label: 'Mensaje',
                    type: 'textarea',
                    id: 'mensaje',
                    placeholder: 'Déjanos un mensaje aquí'
                },
                {
                    label: 'Enviar Mensaje',
                    type: 'submit',
                    id: 'submit',
                }
            ]}
            redirect={`${root}computo.html`}
        />
        <Footer />
        <Chatbot />
    </StrictMode>
)